<mat-toolbar class='app-header'>
    <app-layout-curtain [open]="curtainOpen" (closed)="closeCurtain()"
        (addLayoutStateChanged)="addLayoutActive = $event" *ngIf="showLayoutSettings">
    </app-layout-curtain>
    <div class='app-logo col-4'>
        <img [src]="utility.getImagePath('RAMsysSentrl_Black.svg')" alt="app-logo" class="app-logo-img"
            (click)="goToDashBoard()" draggable="false">
    </div>

    <div class='client-logo col-4' (click)="toggleCurtain()">
        <img class="client-logo-img" alt="client-logo" [src]="logoUrl" draggable="false">
    </div>

    <div class='user-info col-4'>
        <div *ngIf="trialPeriodRemaining && trialPeriodRemaining.days < 30 " class='trial-period'>
            <span>
                <span class="evaluation-text">{{ "HEADER.EVALUATION_LICENSE_TEXT" | translate }}</span> {{
                "HEADER.TRIAL_DAYS_REMAINING_TEXT" | translate }} {{trialPeriodRemaining.days}}
            </span>
        </div>

        <div class='data-time'>
            <span class="current-date">{{ currentDate }}</span>,
            <span class="current-time">{{ currentTime }}</span>
        </div>

        <div (clickOutside)="isShowingUserDropdown=false" appClickOutside>
            <div class="user-details">
                <img [src]="userImage" alt="profile" class="avatar" draggable="false">
                <div class="user-profile">
                    <span class="user-name" matTooltip="{{session?.firstName + ' ' + session?.lastName}}">
                        {{session?.firstName}} {{session?.lastName}}
                    </span>
                    <span class="user-role">{{session?.role?.name}}</span>
                </div>
                <i class="fa fa-angle-down" aria-hidden="true" [matMenuTriggerFor]="userMenu"></i>
            </div>

            <mat-menu #userMenu="matMenu">
                <button mat-menu-item (click)="goToDashBoard()">
                    {{ "HEADER.DASHBOARD" | translate }}
                </button>
                <button *ngIf="isOperator || isAdmin" mat-menu-item (click)="goToReportsPage()">
                    {{ "HEADER.HISTORY" | translate }}
                </button>
                <button *ngIf="isSupervisor" mat-menu-item (click)="goTOAnalyticalDashboard()">
                    {{ "HEADER.ANALYTICAL_DASHBOARD" | translate }}
                </button>
                <button mat-menu-item (click)="logout()">
                    {{ "HEADER.SIGN_OUT" | translate }}
                </button>
            </mat-menu>
        </div>
    </div>
</mat-toolbar>